module.exports = __webpack_public_path__ + "img/pay.c55ec573.svg";